import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiUpdateInvitationResponseBody } from '../InvitationsApi.types';
import { useApi } from '~/lib/api/useApi';
import { organizationUsersQueryKeyFactory } from '../../Organizations/hooks/useOrganizationUsersQuery';
import { invitationQueryKeyFactory } from './useInvitationQuery';
import { organizationInvitationsQueryKeyFactory } from './useOrganizationInvitationsQuery';

export type IUseResendInvitationMutationValues = {
  organizationId: string;
  invitationId: string;
};

export const useResendInvitationMutation = (): UseMutationResult<
  IApiUpdateInvitationResponseBody,
  unknown,
  IUseResendInvitationMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseResendInvitationMutationValues) =>
      api.invitations.resend(values.invitationId),
    onSuccess: async (_, values) =>
      Promise.all(
        [
          { queryKey: organizationInvitationsQueryKeyFactory(values) },
          { queryKey: invitationQueryKeyFactory(values) },
          { queryKey: organizationUsersQueryKeyFactory(values) },
        ].map((filters) => queryClient.invalidateQueries(filters)),
      ),
  });
};
